import { getProductName } from './productTypes';

export const getProductTypeName = (num, amount = 1) => {
  return getProductName(num, amount);
};
